
type Props = {}

export default function TermsAndConditions({ }: Props) {
    return (
        <div>TermsAndConditions</div>
    )
}